import { UPDATE_BOTS } from '../../mutation-types';
import botService from '../../../services/bot-service';

const actions = {
  getBots({ commit }) {
    return botService.getBots().then((response) => {
      commit(UPDATE_BOTS, response.data);
    });
  },
};

export default actions;
